import { useMeasure } from "react-use";
import WeeklyProduction from "../Charts/WeeklyProduction";
import ProductionOeeChart from "../Charts/ProductionOeeChart";
import ShiftBreakdown from "../Charts/ShiftBreakdown";
import { PciChartDataType } from "../../../../../types";
import { PAGE_WIDTH_FOR_PRINT_PCI } from "../../../../../constants/constants";

export const THIRD_OF_PAGE = 419; // this is a third of the remaining page after

export default function PciPerformanceReport({
  completedYearlyData,
  currentWeekNumber,
  shiftsDataArray,
  oeeTarget,
  shouldSetWidth = false,
}: {
  completedYearlyData: PciChartDataType[] | null;
  currentWeekNumber: number;
  shiftsDataArray: PciChartDataType[] | null;
  oeeTarget?: number;
  shouldSetWidth?: boolean;
}) {
  const [ref, { width }] = useMeasure<HTMLDivElement>();
  return (
    <div ref={ref} className="reportBody">
      <WeeklyProduction
        data={completedYearlyData}
        width={shouldSetWidth ? PAGE_WIDTH_FOR_PRINT_PCI : width}
        height={THIRD_OF_PAGE}
      />
      <ProductionOeeChart
        data={shiftsDataArray}
        width={shouldSetWidth ? PAGE_WIDTH_FOR_PRINT_PCI : width}
        height={THIRD_OF_PAGE}
        oeeTarget={oeeTarget}
      />
      <ShiftBreakdown
        data={shiftsDataArray}
        width={shouldSetWidth ? PAGE_WIDTH_FOR_PRINT_PCI : width}
        height={THIRD_OF_PAGE}
      />
    </div>
  );
}
